<template>
  <v-app id="inspire">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <template v-for="item in items">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
              router-link
              :to="child.route"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item  v-else :key="item.text" link router-link :to="item.route">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item color="#00a972" @click="appLogout">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      class="primary"
      height="50px"
      dark
      elevation="1"
    >
      <v-app-bar-nav-icon @click.stop="drawer=!drawer" />
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span>Leopard Tech Labs</span>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items v-if="!appLogin" class="nav_item hidden-sm-and-down">
        <!-- <v-row justify="center"> -->
        <router-link to="/Login">
          <v-btn text :ripple="false" depressed class="nav_item AppMenu">LOG IN</v-btn>
        </router-link>
        <v-spacer></v-spacer>
      </v-toolbar-items>
      
      <v-toolbar-items v-else class="nav_item hidden-sm-and-down">
        <v-row justify="center">
          <v-menu
            :close-on-content-click="false"
            :nudge-bottom="40"
            :nudge-right="50"
            transition="slide-y-transition"
            style="padding-top:40px;"
            bottom
            dark
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                :ripple="false"
                class="nav_item"
                depressed
                v-on="on"
              >ADMIN</v-btn>
            </template>
            <v-card max-width="350">
              <v-layout pa-3>
                <v-flex>
                  <router-link to="/Profile">
                    <v-layout style="cursor:pointer;">
                      <v-flex>
                        <span style="font-size:12px;color:white">Account Settings</span>
                      </v-flex>
                      <v-flex pl-3>
                        <v-icon style="font-size:14px;">mdi-settings</v-icon>
                      </v-flex>
                    </v-layout>
                  </router-link>
                  <v-divider></v-divider>
                  <v-layout @click="appLogout" style="cursor:pointer;">
                    <v-flex text-left>
                      <span style="font-size:12px;">Sign Out</span>
                    </v-flex>
                    <v-flex text-right>
                      <v-icon style="font-size:14px;">mdi-logout</v-icon>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-menu>
          <v-spacer></v-spacer>
        </v-row>
      </v-toolbar-items>
    </v-app-bar>
    <!-- <v-toolbar height="5px" elevation="0"></v-toolbar> -->
    <v-content>
      <v-container class="fill-height" style="overflow-x:scroll;padding:0!important;">
        <v-row align="center" justify="center">
          <router-view style="min-height: 80vh;"></router-view>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";
import store from "./../store";
import VueElementLoading from "vue-element-loading";

export default {
  components: {
    VueElementLoading
  },
  computed: {
    appLogin() {
      return store.state.isLoggedIn;
    }
  },
  data() {
    return {
      appLoading: false,
      drawer: true,
      items: [
        {
          icon: "mdi-view-dashboard",
          text: "Dashboard",
          route: "/Dashboard",
          color: "#2196F3"
        },
        // {
        //   icon: "mdi-home-modern",
        //   text: "Project Category",
          
        //   color: "#2196F3",
        //   children: [
        //     {
        //       text: "Conservation Technology",
        //       route: "/ConservationTechnology",
        //       icon: "mdi-home-modern"
        //     },
        //     {
        //       text: "IT Consultancy Service",
        //       route: "/ITConsultancyService",
        //       icon: "mdi-home-modern"
        //     },
        //     {
        //       text: "Research Development",
        //       route: "/Research&Development",
        //       icon: "mdi-home-modern"
        //     },
        //     {
        //       text: "Enterprise Solutions",
        //       route: "/EnterpriseSolutions",
        //       icon: "mdi-home-modern"
        //     }

        //   ]
        // },
        {
          icon: "mdi-cube-outline",
          text: "Projects",
          route: "/Projects",
          color: "#2196F3"
        },

        {
          icon: "mdi-account-multiple",
          text: "Team",
          route: "/Team",
          color: "#2196F3"
        },

        {
          icon: "mdi-account-multiple-plus",
          text: "Partners",
          route: "/Partners",
          color: "#2196F3"
        },

        {
          icon: "mdi-comment-question-outline",
          text: "Manage Contact Us",
          route: "/Contactus",
          color: "#2196F3"
        },

        {
          icon: "mdi-note-text",
          text: "Manage Careers",
          route: "/Careers",
          color: "#2196F3"
        },

        {
          icon: "mdi-note-text",
          text: "Manage Internship/Training",
          route: "/Interntraining",
          color: "#2196F3"
        }
      ],
      msg: null,
      userName: null
    };
  },
  beforeMount() {
    this.getProfile();
  },
  methods: {
    appLogout() {
       if (store.state.isLoggedIn) {
        localStorage.removeItem("token");
        store.commit("logoutUser");
        this.$router.push({ path: "/Login" });
      }
    },
    getProfile() {
      // this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.userName = response.data.data.username;
        })
        .catch(err => {
          this.msg = err.response.data.msg;
          this.appLoading = false;
        });
    }
  }
};
</script>
<style>
.nav_item {
  margin-top: 5px;
  margin-right: 20px;
}
.AppHeading {
  color: white;
  font-family: proxima;
  font-size: 16px;
  font-weight: 800 !important;
  letter-spacing: 1px !important;
}
.AppMenu {
  color: white;
  font-family: poppins;
  font-size: 12px !important;
  font-weight: 100 !important;
  text-transform: uppercase;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px grey;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #0964b9;
  /* border-radius: 10px; */
}
.v-list-group__items {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding-left: 27px;
}
</style>

